import { Injectable } from '@angular/core';

import { ChangePasswordDTO, RidangoEpic, RidangoReduxAction } from '@ridango/core';

import { ActionsObservable } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { Authenticator } from '../../services';
import { ChangePasswordActions } from './change-password.actions';

@Injectable({
    providedIn: 'root'
})
export class ChangePasswordEpics implements RidangoEpic {
    constructor(
        private actions: ChangePasswordActions,
        private auth: Authenticator
    ) {}

    register() {
        return [this.changePassword];
    }

    changePassword = (action$: ActionsObservable<RidangoReduxAction<ChangePasswordDTO>>) =>
        action$.ofType(ChangePasswordActions.SET_NEW_PASSWORD).pipe(
            switchMap((action: RidangoReduxAction<ChangePasswordDTO>) => {
                return this.auth.changePassword(action.payload).pipe(
                    map((d: any) => this.actions.setNewPasswordSuccess(d)),
                    catchError((error) => {
                        if (error.name && error.status === 0) {
                            const browserError = { error: error.name };
                            return of(this.actions.setNewPasswordFailed(browserError));
                        }

                        return of(this.actions.setNewPasswordFailed(error));
                    })
                );
            })
        );
}
